import { render, staticRenderFns } from "./CardSimpleStyle.vue?vue&type=template&id=4f4142d4&"
import script from "./CardSimpleStyle.vue?vue&type=script&lang=js&"
export * from "./CardSimpleStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/CardSimpleStyle.vue"
export default component.exports